import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportOrderStatusService extends GenericService {
    constructor() {
        super('/reports/order_status', axiosInstance);
    }
}

export default new ReportOrderStatusService(); 